import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

// 🔴 Path này PHẢI khớp link mail BE dựng: `${origin}/reset-password` (`booknow/backend` →
// `mail.service.ts`). Đổi một bên mà quên bên kia là mail đặt lại mật khẩu rơi vào notFound —
// người dùng mất hẳn đường lấy lại tài khoản. STORY-921 Q4 đổi CẢ HAI cùng lúc; assert ở
// `router/__tests__/auth-public-routes.spec.ts` khoá chiều FE.
export const resetPasswordRoutes = {
  name: 'reset-password',
  path: 'reset-password',
  components: {
    default: () => import('./ResetPassword.vue'),
    brand: () => import('./ResetPasswordBrand.vue'),
  },
  meta: {
    i18n,
    authHeader: { titleKey: 'resetPassword.createNewPasswordHeading', subtitleKey: 'resetPassword.createNewPasswordSubtitle' },
  },
} satisfies RouteRecordRaw;
